import OnboardingFinal from './OnboardingFinal'

export default OnboardingFinal
// eslint-disable-next-line import/export
export * from './OnboardingFinal'
